import { ItineraryRequest } from 'models/request/transport';

import {
  IChangeTransportError,
  IChangeTransportTypes,
  IChangeTransportData,
} from './types';

export const changeFileTransport = (
  file: File | null,
  type: 'front' | 'back',
  numberVT?: string | null,
) => ({
  type: IChangeTransportTypes.CHANGE_TRANSPORT_SET_DATA,
  payload: {
    file,
    type,
    numberVT,
  },
});

export const changeConfirmedAddressOrUnit = (
  confirmed: 'Sim' | 'Não',
  callNumber?: string | null,
  typeCall?: 'address' | 'unit',
) => ({
  type: IChangeTransportTypes.CHANGE_TRANSPORT_ADDRESS_OR_UNIT,
  payload: {
    confirmed,
    callNumber,
    typeCall,
  },
});

export const changeItinerary = (
  typeItinerary: 'ida' | 'volta',
  itinerary: ItineraryRequest[],
) => ({
  type: IChangeTransportTypes.CHANGE_TRANSPORT_ITINERARY,
  payload: {
    typeItinerary,
    itinerary,
  },
});

export const changeTransportRequest = ({
  data,
  handleClickNextStep,
}: {
  data: IChangeTransportData;
  handleClickNextStep: () => void;
}) => ({
  type: IChangeTransportTypes.CHANGE_TRANSPORT_REQUEST,
  payload: {
    data,
    handleClickNextStep,
  },
});

export const changeTransportSuccess = () => ({
  type: IChangeTransportTypes.CHANGE_TRANSPORT_SUCCESS,
});

export const changeTransportFailure = (error: IChangeTransportError) => ({
  type: IChangeTransportTypes.CHANGE_TRANSPORT_FAILURE,
  payload: {
    error,
  },
});
